export const foodsData = [
    {
        id: 1,
        name: 'Chicken Pot',
        price: '2000',
        imageUrl: 'https://raw.githubusercontent.com/Dabsia/lunchup/develop/src/assets/chickenpot.png'
    },
    {
        id: 2,
        name: 'Jellof Rice',
        price: '800',
        imageUrl: 'https://raw.githubusercontent.com/Dabsia/lunchup/develop/src/assets/jellof.png'
    },
    {
        id: 3,
        name: 'Fried Rice',
        price: '1200',
        imageUrl: 'https://raw.githubusercontent.com/Dabsia/lunchup/develop/src/assets/friedrice.png'
    },
    {
        id: 4,
        name: 'White Rice',
        price: '1000',
        imageUrl: 'https://raw.githubusercontent.com/Dabsia/lunchup/develop/src/assets/whiterice.png'
    },
    {
        id: 5,
        name: 'Meat Pie',
        price: '500',
        imageUrl: 'https://raw.githubusercontent.com/Dabsia/lunchup/develop/src/assets/meatpie.png'
    },
    {
        id: 6,
        name: 'Roasted Chicken',
        price: '1300',
        imageUrl: 'https://raw.githubusercontent.com/Dabsia/lunchup/develop/src/assets/roastedchicken.png'
    },
    {
        id: 7,
        name: 'Burger',
        price: '700',
        imageUrl: 'https://raw.githubusercontent.com/Dabsia/lunchup/develop/src/assets/burger.png'
    },
    {
        id: 8,
        name: 'Sausage Roll',
        price: '400',
        imageUrl: 'https://raw.githubusercontent.com/Dabsia/lunchup/develop/src/assets/sausage.png'
    },
    {
        id: 9,
        name: 'Coke',
        price: '300',
        imageUrl: 'https://raw.githubusercontent.com/Dabsia/lunchup/develop/src/assets/coke.png'
    }
    
]